import BaseModel from "../../../../core/components/input-widget/BaseModel";
import i18n from "../../../../shared/i18n";

export default class StateModel extends BaseModel {
  name = '';
  alpha_code = '';
  country_code = '';
  tax_rate = null;
  exclude_tax_for_premium = false;
  is_economic_nexus_threshold_reached = false;

  rules = {
    name: 'required',
    alpha_code: 'required',
    country_code: 'required',
    tax_rate: 'required',
  };

  attributeLabels = {
    name: i18n.t('Name'),
    alpha_code: i18n.t('Alpha Code'),
    country_code: i18n.t('Country'),
    tax_rate: i18n.t('Tax Rate'),
    exclude_tax_for_premium: i18n.t('Exclude Tax For Premium'),
    is_economic_nexus_threshold_reached: i18n.t('Is Economic Nexus Threshold Reached'),
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}